import { render } from "./AiModels.vue?vue&type=template&id=6b670377&scoped=true"
import script from "./AiModels.vue?vue&type=script&lang=js"
export * from "./AiModels.vue?vue&type=script&lang=js"

import "./AiModels.vue?vue&type=style&index=0&id=6b670377&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b670377"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiModels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b670377"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b670377', __exports__)) {
    api.reload('6b670377', __exports__)
  }
  
  module.hot.accept("./AiModels.vue?vue&type=template&id=6b670377&scoped=true", () => {
    api.rerender('6b670377', render)
  })

}


export default __exports__